<script>
  /* global Global */
  export let page;
  export let lang = undefined;
  export let display = true;
  export let savePage = true;
  export let user = undefined;
  export let mode = undefined;
  export let USER_PAGES;
  export let ADMIN_PAGES;

  if (savePage) {
    const previousPage = window.localStorage.getItem('currentPage');

    if (previousPage && previousPage !== (page === 'home' ? './' : './#/' + page)) {
      window.localStorage.setItem('previousPage', previousPage);
    }
    window.localStorage.setItem('currentPage', page === 'home' ? './' : './#/' + page);
  }

  window.addEventListener('beforeunload', () => {
    window.localStorage.removeItem('previousPage');
    window.localStorage.removeItem('currentPage');
  });

  let displayMenuDropdown = false;
  let displayAccountDropdown = false;

  function openOrCloseMenuDropdown () {
    displayMenuDropdown = !displayMenuDropdown;
  }

  function openOrCloseAccountDropdown () {
    displayAccountDropdown = !displayAccountDropdown;
  }

  function switchLanguage () {
    lang = lang !== 'en' ? 'en' : 'cs';
    window.localStorage.setItem('lang', lang);
  }

  function switchMode () {
    mode = mode !== 'light' ? 'light' : 'dark';
    window.localStorage.setItem('mode', mode);

    window.document.body.classList.toggle('dark');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', mode !== 'dark' ? Global.color.primary : Global.color.primaryDark);
  }

  lang = window.localStorage.getItem('lang');
  mode = window.localStorage.getItem('mode');

  if (!lang) {
    if (/^cs|sk\b/.test(navigator.language)) {
      lang = 'cs';
      window.localStorage.setItem('lang', 'cs');
    } else {
      lang = 'en';
      window.localStorage.setItem('lang', 'en');
    }
  }

  if (!mode) {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      mode = 'dark';
      window.localStorage.setItem('mode', 'dark');

      window.document.body.classList.add('dark');
      document.querySelector('meta[name="theme-color"]').setAttribute('content', Global.color.primaryDark);
    } else {
      mode = 'light';
      window.localStorage.setItem('mode', 'light');
    }
  } else if (mode === 'dark') {
    window.document.body.classList.add('dark');

    document.querySelector('meta[name="theme-color"]').setAttribute('content', Global.color.primaryDark);
  }

  const projectName = Global.project.name;
  const projectLogoExt = Global.project.logoExt;
  const projectLogoAlt = Global.project.logoAlt;
  const projectLinkAlt = Global.project.linkAlt;
</script>

{#if display}
  <header>
    <div class='header-prepend'/>

    <div class='header'>
      <div class='header-left'>
        <a href='./' class='header-left-graphic'>
          <img class='header-left-graphic-image' src='img/static/{projectLogoExt}.svg' alt='{projectName[lang]} logo'/>
        </a>

        {#if projectLogoAlt && projectLinkAlt}
          <a href={projectLinkAlt} class='header-left-graphic'>
            <img class='header-left-graphic-image' src='img/static/{projectLogoAlt}.svg' alt='{projectName[lang]} logo'/>
          </a>
        {/if}
      </div>

      <div class='header-center'>
        <a href='./' class='header-element header-home'
          class:header-element-active={/^(admin\/)?home|articles($|\/)/.test(page)}>

          <div> {lang !== 'en' ? 'Domů' : 'Home'} </div>
        </a>

        {#each USER_PAGES as userPage}
          <a href='./#/{userPage.code}' class='header-element header-{userPage.code}'
            class:header-element-active={new RegExp('^(admin/)?' + userPage.code + '($|/)').test(page)}>

            <div> {userPage.label[lang]} </div>
          </a>
        {/each}
      </div>

      <div class='header-right'>
        <div class='header-element header-language' on:click={switchLanguage}>
          <img class='header-language-flag' src='img/static/flag/{lang !== 'en' ? 'gbr' : 'cze'}.svg'
            alt='{lang !== 'en' ? 'Great Britain' : 'Czechia'} flag'/>
        </div>

        <div class='header-element header-mode' on:click={switchMode}>
          <div> <span class='header-mode-icon material-icons'> {mode !== 'dark' ? 'dark_mode' : 'light_mode'} </span> </div>
        </div>

        {#if !user}
          <a href='./#/login' class='header-element header-login'>
            <div> <span class='header-login-icon material-icons'> login </span> </div>
          </a>
        {:else}
          <div class='header-element header-account' on:click={openOrCloseAccountDropdown}
            class:header-element-active={/^settings($|\/)/.test(page)}>

            <div> <span class='header-account-icon material-icons'> person </span> </div>

            <div class='header-account-space'/>

            <div class='header-account-dropdown' class:header-account-dropdown-display={displayAccountDropdown}>
              {#each ADMIN_PAGES.filter(adminPage => user.roles.includes(adminPage.role)) as adminPage}
                {#if adminPage.link}
                  <a href={adminPage.link} target='_blank' class='header-account-dropdown-element'>
                    <div> {adminPage.label[lang]} <span class='material-icons'> {adminPage.icon} </span> </div>
                  </a>
                {:else}
                  <a href='./#/{adminPage.code}' class='header-account-dropdown-element'>
                    <div> {adminPage.label[lang]} <span class='material-icons'> {adminPage.icon} </span> </div>
                  </a>
                {/if}
              {/each}
            </div>
          </div>
        {/if}
      </div>

      <div class='header-menu'>
        <div class='header-menu-prepend'>
          <a href='./' class='header-menu-prepend-graphic'>
            <img class='header-menu-prepend-graphic-image' src='img/static/{projectLogoExt}.svg' alt='{projectName[lang]} logo'/>
          </a>

          {#if projectLogoAlt && projectLinkAlt}
            <a href={projectLinkAlt} class='header-menu-prepend-graphic'>
              <img class='header-menu-prepend-graphic-image' src='img/static/{projectLogoAlt}.svg' alt='{projectName[lang]} logo'/>
            </a>
          {/if}
        </div>

        <div class='header-element header-menu-element' on:click={openOrCloseMenuDropdown}>
          <div>
            <span class='material-icons'> {!displayMenuDropdown ? 'menu' : 'close'} </span>
            {!displayMenuDropdown ? 'Menu' : lang !== 'en' ? 'Zavřít' : 'Close'}
          </div>
        </div>

        <div class='header-menu-dropdown' class:header-menu-dropdown-display={displayMenuDropdown}>
          <a href='./' class='header-menu-dropdown-element header-menu-dropdown-home'
            class:header-menu-dropdown-element-active={/^(admin\/)?home|articles($|\/)/.test(page)}>

            <div> {lang !== 'en' ? 'Domů' : 'Home'} </div>
          </a>

          {#each USER_PAGES as userPage}
            <a href='./#/{userPage.code}' class='header-menu-dropdown-element header-menu-dropdown-{userPage.code}'
              class:header-menu-dropdown-element-active={new RegExp('^(admin/)?' + userPage.code + '($|/)').test(page)}>

              <div> {userPage.label[lang]} </div>
            </a>
          {/each}

          {#if !user}
            <a href='./#/login' class='header-menu-dropdown-element header-menu-dropdown-login'
              class:header-menu-dropdown-element-active={/^settings($|\/)/.test(page)}>

              <div> {lang !== 'en' ? 'Přihlásit se' : 'Login'} <span class='material-icons'> login </span> </div>
            </a>
          {:else}
            <div class='header-menu-dropdown-element header-menu-dropdown-account'>
              <div> {user.firstName} {user.lastName} <span class='material-icons'> person </span> </div>
            </div>

            {#each ADMIN_PAGES.filter(adminPage => user.roles.includes(adminPage.role)) as adminPage}
              {#if adminPage.link}
                <a href={adminPage.link} target='_blank' class='header-menu-dropdown-element header-menu-dropdown-account-element'>
                  <div> {adminPage.label[lang]} <span class='material-icons'> {adminPage.icon} </span> </div>
                </a>
              {:else}
                <a href='./#/{adminPage.code}' class='header-menu-dropdown-element header-menu-dropdown-account-element'>
                  <div> {adminPage.label[lang]} <span class='material-icons'> {adminPage.icon} </span> </div>
                </a>
              {/if}
            {/each}
          {/if}

          <div class='header-menu-dropdown-element header-menu-dropdown-mode' on:click={switchMode}>
            <div>
              {#if lang !== 'en'}
                {mode !== 'dark' ? 'Tmavý mód' : 'Světlý mód'}
              {:else}
                {mode !== 'dark' ? 'Dark mode' : 'Light mode'}
              {/if}
              <span class='material-icons'> {mode !== 'dark' ? 'dark_mode' : 'light_mode'} </span>
            </div>
          </div>

          <div class='header-menu-dropdown-element header-menu-dropdown-language' on:click={switchLanguage}>
            <div> {lang !== 'en' ? 'English' : 'Česky'} </div>

            <img class='header-menu-dropdown-language-flag' src='img/static/flag/{lang !== 'en' ? 'gbr' : 'cze'}.svg'
              alt='{lang !== 'en' ? 'Great Britain' : 'Czechia'} flag'/>
          </div>
        </div>
      </div>
    </div>

    <div class='header-append'/>
  </header>
{/if}

<style>
  header {
    position: sticky;
    top: 0px;

    display: flex;

    height: 60px;

    padding-top: 10px;

    z-index: 3;
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-basis: 1450px;

    padding: 0px 20px;

    border-radius: 30px;

    background: var(--primary);
  }

  .header-prepend {
    flex-grow: 1;

    min-width: 40px;
  }

  .header-append {
    flex-grow: 1;

    min-width: 40px;
  }

  .header-left {
    display: flex;
    justify-content: flex-start;
    gap: 20px;

    width: 160px;

    padding-left: 10px;
  }

  .header-left-graphic {
    height: calc(100% - 20px);

    padding: 10px 0px;
  }

  .header-left-graphic-image {
    height: 100%;
  }

  .header-center {
    display: flex;
    gap: 10px;
  }

  .header-right {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    width: 160px;

    padding-right: 10px;
  }

  .header-menu {
    position: relative;

    display: none !important;
    gap: 20px;

    width: 100%;
  }

  .header-menu-prepend {
    display: flex;
    flex-shrink: 4;
    gap: 20px;

    width: 160px;

    padding-left: 10px;
  }

  .header-menu-prepend-graphic {
    height: calc(100% - 20px);

    padding: 10px 0px;
  }

  .header-menu-prepend-graphic-image {
    height: 100%;
  }

  .header-element {
    display: flex;
    align-items: center;

    height: 20px;

    padding: 10px 20px;

    margin: 10px 0px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    color: var(--white);

    transition: background-color 0.5s ease-in-out;
  }

  @media (hover: hover) { .header-element:not(.header-element-active):hover {
    background-color: rgba(255, 255, 255, 0.2);
  }}

  .header-element-active {
    background: var(--white);
    color: var(--primary);
  }

  .header-language {
    justify-content: center;

    padding: 10px;

    cursor: pointer;
  }

  .header-language-flag {
    height: 20px;

    border-radius: var(--radius-sm);
  }

  .header-mode {
    padding: 10px;

    cursor: pointer;
  }

  .header-mode-icon {
    font-size: 20px;

    line-height: 1;
  }

  .header-login {
    padding: 10px;

    cursor: pointer;
  }

  .header-login-icon {
    font-size: 20px;

    line-height: 1;
  }

  .header-account {
    position: relative;

    padding: 10px;

    cursor: pointer;
  }

  .header-account-icon {
    font-size: 20px;

    line-height: 1;
  }

  .header-account-space {
    position: absolute;
    top: 40px;
    left: 0px;

    display: none;

    width: 100%;
    height: 20px;

    background: transparent;
  }

  .header-account-dropdown {
    position: absolute;
    top: 60px;
    left: 15px;

    display: none;

    width: 100%;
    min-width: 215px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);

    box-shadow: 0 0 5px 0 var(--grey-6);

    transform: translateX(-75%);
  }

  @media (hover: hover) { .header-account:hover .header-account-space, .header-account:hover .header-account-dropdown  {
    display: block;
  }}

  .header-account-dropdown-display {
    display: block;
  }

  .header-account-dropdown-element {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    padding: 10px 20px;

    margin: 10px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    color: var(--black);

    user-select: none;

    transition: background-color 0.5s ease-in-out;
  }

  .header-account-dropdown-element:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .header-menu-element {
    display: flex;
    justify-content: center;

    width: 100%;

    margin: 10px;

    cursor: pointer;
  }

  .header-menu-dropdown {
    position: absolute;
    top: 70px;
    left: -20px;

    display: none;

    width: calc(100% + 40px);
    max-height: calc(100vh - 90px);

    z-index: 4;

    border-radius: var(--radius-lg);

    background: var(--grey-1);

    box-shadow: 0 0 5px 0 var(--grey-6);

    overflow-y: scroll;
  }

  .header-menu-dropdown-display {
    display: block;
  }

  .header-menu-dropdown-element {
    display: flex;
    align-items: center;

    height: 20px;

    padding: 10px 20px;

    margin: 10px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    color: var(--black);

    user-select: none;
  }

  .header-menu-dropdown-element:not(.header-menu-dropdown-element-active):not(.header-menu-dropdown-account):hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .header-menu-dropdown-element-active {
    background: var(--primary);
    color: var(--white);
  }

  .header-menu-dropdown-account {
    font-weight: bold;
  }

  .header-menu-dropdown-account-element {
    padding-left: 40px;
  }

  .header-menu-dropdown-language-flag {
    height: 16px;

    margin: 3px 0px 2px 10px;

    border-radius: var(--radius-sm);
  }

  :global(body.dark) .header {
    background: var(--primary-dark);
  }

  :global(body.dark) .header-left-graphic-image,
  :global(body.dark) .header-menu-prepend-graphic {
    filter: brightness(88%);
  }

  :global(body.dark) .header-element {
    color: var(--grey-3);
  }

  :global(body.dark) .header-element-active {
    background: var(--grey-3);
    color: var(--primary-dark);
  }

  :global(body.dark) .header-account-dropdown {
    background: var(--grey-8);

    box-shadow: 0 0 5px 0 var(--black);
  }

  :global(body.dark) .header-account-dropdown-element {
    color: var(--grey-3);
  }

  :global(body.dark) .header-account-dropdown-element:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .header-menu-dropdown {
    background: var(--grey-8);

    box-shadow: 0 0 5px 0 var(--black);
  }

  :global(body.dark) .header-menu-dropdown-element {
    color: var(--grey-3);
  }

  :global(body.dark) .header-menu-dropdown-element:not(.header-menu-dropdown-element-active):not(.header-menu-dropdown-account):hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .header-menu-dropdown-element-active {
    background: var(--grey-3);
    color: var(--grey-9);
  }

  @media only screen and (max-width: 1300px) {
    header {
      width: 100%;
    }

    .header-left, .header-center, .header-right {
      display: none;
    }

    .header-menu {
      display: flex !important;
    }
  }

  @media only screen and (max-width: 900px) {
    .header-prepend, .header-append {
      min-width: 20px;
    }
  }

  @media only screen and (max-width: 400px) {
    .header-menu-prepend {
      display: none;
    }
  }
</style>
